export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS = "CONTRACT_CONFIGURATION_LIST_DATA_SUCCESS";
export const CONTRACT_CONFIGURATION_BY_ID = "CONTRACT_CONFIGURATION_BY_ID";